import { Tag } from 'antd';
import { trangThaiHopDongDienTu } from '../../constants';

const trangThaiTagMap: Record<number, { color: string; label: string }> = {
    [trangThaiHopDongDienTu.khoiTao]: { color: "processing", label: "Khởi tạo" },
    [trangThaiHopDongDienTu.thuHoi]: { color: "warning", label: "Thu hồi" },
    [trangThaiHopDongDienTu.nguoiKyNhayTraLai]: { color: "error", label: "Lãnh đạo VP trả lại" },
    [trangThaiHopDongDienTu.trinhNguoiKyNhay]: { color: "purple", label: "Trình lãnh đạo VP" },
    [trangThaiHopDongDienTu.chuyenNhanVien]: { color: "cyan", label: "Chuyển nhân viên" },
    [trangThaiHopDongDienTu.chuyenNguoiKyNhay]: { color: "gold", label: "Chuyển lãnh đạo VP" },
    [trangThaiHopDongDienTu.chuyenGiamDoc]: { color: "blue", label: "Chuyển giám đốc" },
    [trangThaiHopDongDienTu.chuyenVanThu]: { color: "geekblue", label: "Chuyển văn thư" },
    [trangThaiHopDongDienTu.hoanThanh]: { color: "success", label: "Thành công" },
    [trangThaiHopDongDienTu.kichHoat]: { color: "green", label: "Đã kích hoạt" },
};

/// Danh sách trạng thái cho select box lọc, lấy luôn từ map để nhãn không lệch với tag
export const dsTrangThaiHopDongDienTu = Object.keys(trangThaiTagMap).map((key) => ({
    value: Number(key),
    label: trangThaiTagMap[Number(key)].label,
}));

const TrangThaiHopDongDienTuTag = ({ value }: { value?: number | null }) => {
    if (value === undefined || value === null) return null;

    const config = trangThaiTagMap[value];

    if (!config) return <span></span>;

    return <Tag color={config.color}>{config.label}</Tag>;
};

export default TrangThaiHopDongDienTuTag;
